// extracted by mini-css-extract-plugin
export default {"second-btn":"index_second-btn__MthB0","second-btn-hover-bg":"index_second-btn-hover-bg__9SoFa"};